{
  "name": "poultry-sense-client",
  "version": "1.0.646",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "test": "ng test --browsers Chrome",
    "citest": "ng test --browsers ChromiumNoSandbox --watch=false --code-coverage --reporters=junit",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "services-upd": "ng-openapi-gen --baseService BaseServiceUrl --input https://poultrysense-v2-dev.mahi-techlabs.com/api/q/openapi?format=json --output src/app/services/api"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/build-angular": "^20.3.31",
    "@angular/animations": "^20.3.25",
    "@angular/cdk": "^20.0.1",
    "@angular/cli": "^20.3.31",
    "@angular/common": "^20.3.25",
    "@angular/compiler": "^20.3.25",
    "@angular/core": "^20.3.25",
    "@angular/forms": "^20.3.25",
    "@angular/platform-browser": "^20.3.25",
    "@angular/platform-browser-dynamic": "^20.3.25",
    "@angular/router": "^20.3.25",
    "@danielmoncada/angular-datetime-picker": "^20.0.1",
    "@okta/okta-auth-js": "^7.12.1",
    "@syncfusion/ej2-angular-charts": "^29.2.8",
    "@syncfusion/ej2-angular-dropdowns": "^29.2.8",
    "@syncfusion/ej2-angular-inputs": "^29.2.5",
    "amazon-quicksight-embedding-sdk": "^2.10.1",
    "autonumeric": "^4.10.8",
    "colormap": "^2.3.2",
    "country-state-city": "^3.2.1",
    "dom-to-image": "^2.6.0",
    "jquery": "^3.7.1",
    "jspdf": "^4.2.0",
    "libphonenumber-js": "^1.12.8",
    "moment": "^2.30.1",
    "moment-timezone": "^0.6.0",
    "ng-openapi-gen": "^0.53.0",
    "ngx-scanner-qrcode": "^1.7.6",
    "ngx-slick-carousel": "^20.0.0",
    "rxjs": "^7.8.2",
    "slick-carousel": "^1.8.1",
    "tslib": "^2.8.1",
    "tslint": "^5.20.1",
    "uuid": "^11.1.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/compiler-cli": "^20.3.25",
    "@types/jasmine": "^5.1.8",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^22.15.29",
    "codelyzer": "^6.0.2",
    "jasmine-core": "^5.7.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "prettier": "^3.5.3",
    "protractor": "^7.0.0",
    "ts-node": "^10.9.2",
    "tslint-consistent-codestyle": "^1.16.0",
    "tslint-lines-between-class-members": "1.3.6",
    "typescript": "^5.8.3"
  },
  "overrides": {
    "webpack-dev-server": "^5.2.4",
    "lodash": "^4.18.0",
    "form-data": "^2.5.6",
    "handlebars": "^4.7.9",
    "node-forge": "^1.4.0",
    "@angular/core": "^20.3.25",
    "@angular/compiler": "^20.3.25",
    "http-proxy-middleware": "^3.0.7",
    "tmp": "^0.2.7"
  }
}
